module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_2_1_2-af78cb84d55bbda6834421cde93734b4.webp";